import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { fetchPost } from "../../utils";
import { Title, Editor } from "..";
import EditTags from "./edit-tags";
import TagSelect from "./tag-select";

export default function New() {
  const [title, setTitle] = useState("");
  const [tags, setTags] = useState([]);
  const history = useHistory();
  const [content, setContent] = useState("");

  const submit = async () => {
    const userUuid = window.localStorage.getItem("hub-userUuid");
    const { body } = await fetchPost({
      data: { content, tags, title, userUuid },
      url: "/api/wiki",
      onError: console.error,
    });

    if (body) {
      history.push(body.path);
    }
  };

  return (
    <>
      <Title title="New post" />

      <h1>Add a new page to your HUB</h1>
      {false && (
        <div>
          <TagSelect
            sendUpdates={false}
            onUpdate={({ nextTag }) =>
              setTags(tags.includes(nextTag) ? tags : [...tags, nextTag])
            }
            currentTags={tags}
          />
          <EditTags
            tags={tags}
            deleteTag={async (tagName) => {
              setTags(tags.filter((tag) => tag !== tagName));
            }}
          />
        </div>
      )}
      <label htmlFor="page-title">Page name</label>
      <input
        autoFocus
        value={title}
        onChange={({ target: { value } }) => {
          setTitle(value);
        }}
        id="page-title"
        type="text"
      />
      <br />
      <Editor
        defaultValue={""}
        defaultRawValue={""}
        handleChange={({ target: { value } }) => setContent(value)}
      />
      <div className="edit-buttons">
        <div></div>
        <button onClick={submit} id="submit-btn">
          Submit
        </button>
      </div>
    </>
  );
}
